import React, { useState } from "react";
import { toast } from "react-toastify";
import { useUpdatePublicDonor } from "../../../hooks/useAdminPublicDonors";

const BLOOD_GROUPS = ["A POSITIVE(+)", "A NEGATIVE(-)", "B POSITIVE(+)", "B NEGATIVE(-)", "O POSITIVE(+)", "O NEGATIVE(-)", "AB POSITIVE(+)", "AB NEGATIVE(-)"];

const PublicDonorEditModal = ({ donor, onClose }) => {
  const [form, setForm] = useState({
    name: donor.name || "",
    number: donor.number || "",
    alternativePhone: donor.alternativePhone || "",
    group: donor.group || "",
    district: donor.district || "",
    area: donor.area || "",
    address: donor.address || "",
    lastDonation: donor.lastDonation || "",
    gender: donor.gender || "",
    dateOfBirth: donor.dateOfBirth || "",
    availability: donor.availability !== false,
    status: donor.status || "active",
  });

  const updateMutation = useUpdatePublicDonor();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateMutation.mutateAsync({ id: donor._id, data: form });
      toast.success("Public donor updated successfully");
      onClose();
    } catch (err) {
      toast.error(err.message || "Failed to update donor");
    }
  };

  return (
    <div className="modal modal-open">
      <div className="modal-box max-w-2xl">
        <h3 className="font-bold text-lg mb-4">Edit Public Donor</h3>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="form-control">
              <label className="label"><span className="label-text">Name</span></label>
              <input type="text" name="name" value={form.name} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Phone</span></label>
              <input type="text" name="number" value={form.number} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Alt Phone</span></label>
              <input type="text" name="alternativePhone" value={form.alternativePhone} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Blood Group</span></label>
              <select name="group" value={form.group} onChange={handleChange} className="select select-bordered select-sm">
                <option value="">Select</option>
                {BLOOD_GROUPS.map((g) => <option key={g} value={g}>{g}</option>)}
              </select>
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">District</span></label>
              <input type="text" name="district" value={form.district} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Area</span></label>
              <input type="text" name="area" value={form.area} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Address</span></label>
              <input type="text" name="address" value={form.address} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Last Donation</span></label>
              <input type="date" name="lastDonation" value={form.lastDonation} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Gender</span></label>
              <select name="gender" value={form.gender} onChange={handleChange} className="select select-bordered select-sm">
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Date of Birth</span></label>
              <input type="date" name="dateOfBirth" value={form.dateOfBirth} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Status</span></label>
              <select name="status" value={form.status} onChange={handleChange} className="select select-bordered select-sm">
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Available</span></label>
              <label className="cursor-pointer label gap-2">
                <input type="checkbox" name="availability" checked={form.availability} onChange={handleChange} className="checkbox checkbox-sm" />
                <span className="label-text">{form.availability ? "Yes" : "No"}</span>
              </label>
            </div>
          </div>
          <div className="modal-action">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className={`btn btn-primary ${updateMutation.isLoading ? "loading" : ""}`} disabled={updateMutation.isLoading}>
              Save Changes
            </button>
          </div>
        </form>
      </div>
      <div className="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};

export default PublicDonorEditModal;
